import React, { useEffect } from "react";
import { useQuery } from "@apollo/client";
import {useHistory} from 'react-router-dom';
import Box from "@mui/material/Box";
import { CURRENT_USER_QUERY } from "../../queries/queries";
import Teaser from "./teaser";
import Error from "../error";
import Loading from "../loading";
import giftIcon from '../../assets/images/gift-box.png';
import ProfileItem from "./profile-item";
import trophyIcon from '../../assets/images/trophy.png';
import personIcon from '../../assets/images/person.png';
import bookmarkIcon from '../../assets/images/bookmark.png';
import heartIcon from "../../assets/images/heart_icon.png";
import hcpIcon from '../../assets/images/hcpIcon.png';

const Profile = ({ handleLogOut }) => {
  let history = useHistory();
  const { loading, error, data } = useQuery(CURRENT_USER_QUERY, {
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    const wrapper = document.querySelector(".scrollable");
    if (!wrapper) return;

    document.querySelector(".scrollable").addEventListener(
      "touchmove",
      function(event) {
        event.stopPropagation();
      },
      false
    );
  });

  if (loading) return <Loading />;
  if (error) return <Error />;

  let user = data.currentUser;
  if (!user) {
    handleLogOut();
  }

  return (
    <Box data-testid="profile">
      {/* <LogoutIcon className={classes.logoutIcon} onClick={handleLogOut} /> */}
      <div className="scrollable">
        <div className="profile-container">
          <Teaser user={user} />
          <ProfileItem
            title={'Meine Punkte'}
            icon={trophyIcon}
            onClick={e => {
              e.preventDefault();
              history.push('/profile-points');
            }}
          />
          <ProfileItem
            title={'Meine Coupons'}
            icon={giftIcon}
            onClick={e => {
              e.preventDefault();
              history.push('/coupons-list');
            }}
          />
          <ProfileItem
            title={'Meine Trainer:innen'}
            icon={personIcon}
            onClick={e => {
              e.preventDefault();
              history.push('/trainer');
            }}
          />
          <ProfileItem
            title={'Meine Zertifikate'}
            icon={bookmarkIcon}
            onClick={e => {
              e.preventDefault();
              history.push('/certificates');
            }}
          />
          {/* <ProfileItem
            title={'Meine Favoriten'}
            icon={heartIcon}
            onClick={e => {
              e.preventDefault();
              history.push('/favorites');             
            }}
          /> */}
          <ProfileItem
            title={'Meine Schulungen'}
            icon={personIcon}
            onClick={e => {
              e.preventDefault();
              history.push('/appointments-list');
            }}
          />
          <ProfileItem
            title={'Gewinnspiele'}
            icon={giftIcon}
            onClick={e => {
              e.preventDefault();
              history.push('/giveaway-list');
            }}
          />
          <ProfileItem
            title={'HCP Portale'}
            icon={hcpIcon}
            fullIcon={true}
            onClick={e => {
              e.preventDefault();
              history.push('/hcp-portale');
            }}
          />
          {/* <Approvals /> */}
        </div>
      </div>
    </Box>
  );
};

export default Profile;
